// Version : 0.0.3
// Author : VIGNESH
// LastEdit: VIGNESH
// MODFIED DATE : 07-12-2025
// LAST MOFIFIED: ADDED COMMENTS AND REMOVED UNWANTED REDUX

const GoldloanInterestReminderReportTypes = {
	/************* GOLD LOAN INTEREST REMINDER REPORT START *********** */
	GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_START: 'get_gold_loan_interest_reminder_report_start',
	GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_SUCCESS: 'get_gold_loan_interest_reminder_success',
	GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_FAILURE: 'get_gold_loan_interest_reminder_failure',
	GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_RESPONSE_RESET:
		'get_gold_loan_interest_reminder_response_reset',
	GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_RESPONSE_CHANGED:
		'get_gold_loan_interest_reminder_response_changed',
	/************* GOLD LOAN INTEREST REMINDER REPORT END *********** */
};

export default GoldloanInterestReminderReportTypes;
